<div class="container">
  <div id="content-container" class="content-container">
    @for (section of sections; track section) {
      <div class="section-header">
        <div class="section-title">{{ getItemTitle(section) }}</div>
        <div class="section-guidance">
          <sag-ui-button icon="circle-help" [square]="true" (click)="showSectionGuidance(section)" />
        </div>
      </div>
      @for (area of section.areas; track area) {
        @if (isAreaDependencySatisfied(section, area)) {
          <div class="main-dynamic-container" id="form-container-{{ $index }}">
            <div class="question-container">
              <div class="question" [innerHTML]="areaDescription(area)"></div>
              @if (area?.guidanceId && !isReleased) {
                @if (IS_TRS_PROJECT) {
                  <sag-ui-button id="guidance-button-{{ $index }}" icon="circle-help" [square]="true" (click)="showGuidance(section, area.guidanceText)" />
                } @else if (IS_PRODUCT_SAFETY_PROJECT) {
                  <sag-ui-button
                    id="guidance-button-{{ $index }}"
                    icon="circle-help"
                    [square]="true"
                    (click)="showGuidance(section, area.guidanceText, area.guidanceTextDe)" />
                }
              }
            </div>

            <div [ngClass]="{ last: $last }" class="flex-row row-container">
              <div class="single-row-container">
                @let rows = area.rows[0];
                @switch (area.questionType) {
                  @case ("text") {
                    @let textField = rows[0];
                    <app-editor
                      [(ngModel)]="report.reportValues[textField.valueId].value"
                      [disabled]="!isEditableAsResponsible || isReleased || isApproved(area)"
                      (valueChange)="editorChanged(section)" />
                  }

                  @case ("yesNo") {
                    @let radioField = rows[0];
                    <div class="yes-no-container">
                      <sag-ui-radio-group>
                        <sag-ui-radio
                          name="radio-group--{{ radioField.valueId }}"
                          value="true"
                          [disabled]="!isEditableAsResponsible || isReleased || isApproved(area)"
                          [(ngModel)]="report.reportValues[radioField.valueId].value"
                          (change)="radioChanged(section, radioField.valueId, $event)"
                          >{{ "generic.truthy.true" | translate }}</sag-ui-radio
                        >
                        <sag-ui-radio
                          name="radio-group--{{ radioField.valueId }}"
                          value="false"
                          [disabled]="!isEditableAsResponsible || isReleased || isApproved(area)"
                          [(ngModel)]="report.reportValues[radioField.valueId].value"
                          (change)="radioChanged(section, radioField.valueId, $event)"
                          >{{ "generic.truthy.false" | translate }}</sag-ui-radio
                        >
                      </sag-ui-radio-group>

                      @let answer = report.reportValues[radioField.valueId].value;
                      @if (showTextArea(area, answer)) {
                        @let textField = rows[1];
                        @let explanation = answer === "true" ? "report.item.explanation.yes" : "report.item.explanation.no";
                        <app-editor
                          [label]="explanation | translate"
                          [required]="area.isExplanationMandatory"
                          [disabled]="!isEditableAsResponsible || isReleased || isApproved(area)"
                          [(ngModel)]="report.reportValues[textField.valueId].value"
                          (valueChange)="editorChanged(section)" />
                      }
                    </div>
                  }

                  @case ("value") {
                    @let valueField = rows[0];
                    <div class="value-container">
                      <div class="flex-row">
                        <sag-ui-input
                          type="number"
                          label="Please enter a numeric value to answer the question:"
                          [value]="report.reportValues[valueField.valueId].value"
                          [disabled]="!isEditableAsResponsible || isReleased || isApproved(area)"
                          [(ngModel)]="report.reportValues[valueField.valueId].value"
                          (change)="onAnswerChanged(section)">
                        </sag-ui-input>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      }
    }
    @if (!hasDocument) {
      <sag-ui-filedrop
        class="main-dynamic-container"
        accept="application/pdf"
        [disabled]="!isEditableAsResponsible"
        [multiple]="false"
        (change)="uploadAttachment($event)">
        <span class="icon-upload"></span>
        <p>
          <b>Click to upload</b>
          or drag and drop
        </p>
        <p class="accepted-files-text">Accepted file types: PDF</p>
      </sag-ui-filedrop>
    } @else {
      <div class="main-dynamic-container">
        <div class="uploaded-document">
          <div class="uploaded-document-item">
            @if (!isReleased) {
              <span (click)="removeAttachment()" class="document-close icon-close"></span>
            }
            <span (click)="downloadAttachment()" class="document-icon icon-document-pdf"></span>
            <div class="document-name">{{ documents[0].name }}</div>
            <div class="document-metadata">
              <span>{{ getFileLastModifiedDate() | date: "dd-MM-yyyy" }}</span>
              <span>{{ getFileSize() }} MB</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
